module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "vtf.5fa2af60.woff";